import {
  sendAnalyticsEvent,
  TSendAnalyticsEventProps,
} from '@/_analytic/send-analytics-event';
import { TAnalyticEventParams } from '@/_analytic/_types';

type TProps = {
  element: Element;
  attributeName: string;
  params?: Partial<TAnalyticEventParams>;
};
export const logDataAttribute = ({
  element,
  attributeName,
  params = {},
}: TProps): void => {
  if (!element.hasAttribute(attributeName)) {
    return;
  }

  const analyticsDataString = element.getAttribute(attributeName) || '';
  const analyticsData = JSON.parse(
    analyticsDataString,
  ) as TSendAnalyticsEventProps;

  sendAnalyticsEvent({
    name: analyticsData?.name,
    params: {
      ...params,
      ...analyticsData?.params,
    },
  });
};
